export default {
  'dashboardandanalysis.analysis.test': 'Gongzhuan No.{no} shop',
  'dashboardandanalysis.analysis.introduce': 'Introduzir',
  'dashboardandanalysis.analysis.total-sales': 'Vendas Totais',
  'dashboardandanalysis.analysis.day-sales': 'Vendas do Dia',
  'dashboardandanalysis.analysis.visits': 'Visitas',
  'dashboardandanalysis.analysis.visits-trend': 'Tendência de Visitas',
  'dashboardandanalysis.analysis.visits-ranking': 'Ranking de Visitas',
  'dashboardandanalysis.analysis.day-visits': 'Visitas do Dia',
  'dashboardandanalysis.analysis.week': 'Taxa Semanal',
  'dashboardandanalysis.analysis.day': 'Taxa Diária',
  'dashboardandanalysis.analysis.payments': 'Pagamentos',
  'dashboardandanalysis.analysis.conversion-rate': 'Taxa de Conversão',
  'dashboardandanalysis.analysis.operational-effect': 'Efeito Operacional',
  'dashboardandanalysis.analysis.sales-trend': 'Tendência de Vendas das Lojas',
  'dashboardandanalysis.analysis.sales-ranking': 'Ranking de Vendas',
  'dashboardandanalysis.$2': 'Todo ano',
  'dashboardandanalysis.analysis.all-month': 'Todo mês',
  'dashboardandanalysis.analysis.all-week': 'Toda semana',
  'dashboardandanalysis.analysis.all-day': 'Todo dia',
  'dashboardandanalysis.analysis.search-users': 'Pesquisa de Usuários',
  'dashboardandanalysis.analysis.per-capita-search': 'Busca Per Capta',
  'dashboardandanalysis.analysis.online-top-search': 'Mais Buscadas Online',
  'dashboardandanalysis.analysis.the-proportion-of-sales': 'The Proportion Of Sales',
  'dashboardandanalysis.channel.all': 'Tudo',
  'dashboardandanalysis.channel.online': 'Online',
  'dashboardandanalysis.channel.stores': 'Lojas',
  'dashboardandanalysis.analysis.sales': 'Vendas',
  'dashboardandanalysis.analysis.traffic': 'Tráfego',
  'dashboardandanalysis.table.rank': 'Rank',
  'dashboardandanalysis.table.search-keyword': 'Palavra chave',
  'dashboardandanalysis.table.users': 'Usuários',
  'dashboardandanalysis.table.weekly-range': 'Faixa Semanal',
};
